import React from 'react'
import getRoutes from '@/lib/getRoutes'
import Link from '@/components/Common/Link'
import { Chip } from '@mui/material'

type Props = {
  hit: any
  className?: string
  type?: string
}

const BrandItem: React.FC<Props> = ({ hit, className, type }) => {
  const isGamme = type === 'gammes'

  const brandSplit = hit.label.split('###')
  const brand = {
    ...hit,
    label: brandSplit[0],
    seo_name: brandSplit[1],
  }

  const urlBrand = getRoutes({
    route: 'Brand',
    values: { '[slug]': brand.seo_name },
  })

  const chipElement = (
    <Chip
      label={isGamme ? hit.label : brand.label}
      variant={'outlined'}
      color="secondary"
      className="w-full font-bold !border-[#4453A1]"
    />
  )

  return (
    <div className={className}>
      {isGamme ? (
        chipElement
      ) : (
        <Link href={urlBrand.href} as={urlBrand.as}>
          {chipElement}
        </Link>
      )}
    </div>
  )
}
export default BrandItem
